import "core-js/modules/es.array.concat.js";
import { getReq, postReq, putReq } from './axios';
var BASE_URL = "".concat(apiUrl, "/partner");
export var getAllPartners = function getAllPartners() {
  return getReq(BASE_URL);
};
export var getPartner = function getPartner(id) {
  return getReq("".concat(BASE_URL, "/").concat(id));
};
export var createPartner = function createPartner(body) {
  return postReq(BASE_URL, body);
};
export var updatePartner = function updatePartner(id, body) {
  return putReq("".concat(BASE_URL, "/").concat(id), body);
};